import {useState} from "react";
import PropTypes from "prop-types";
import {greyishBlue100} from "assets/jss/main";

import MappingRow from "./components/MappingRow";

const fakeItems = [
    {id: 1, title: "Couleurs", unmapped: 12, enabled: true},
    {id: 2, title: "Tailles", unmapped: 5, enabled: true},
    {id: 3, title: "Genre", unmapped: 34, enabled: false},
    {id: 4, title: "Catégorie", unmapped: 8, enabled: true},
];

MappingAttributeAdministration.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            title: PropTypes.string.isRequired,
            unmapped: PropTypes.number.isRequired,
            enabled: PropTypes.bool,
        })
    ),
    onChange: PropTypes.func,
};

function MappingAttributeAdministration({
    items = fakeItems,
    onChange = () => {}
}) {
    const [rows, setRows] = useState(items);

    const handleToggle = (id) => {
        const updated = rows.map((row) =>
            row.id === id ? {...row, enabled: !row.enabled} : row
        );
        setRows(updated);
        onChange(updated);
    };

    return (
        <div style={{
            border: `1px solid ${greyishBlue100}`,
            borderRadius: "8px",
            backgroundColor: "#ffffff",
            overflow: "hidden",
        }}>
            {rows.map((row, index) => (
                <MappingRow
                    key={row.id}
                    title={row.title}
                    unmapped={row.unmapped}
                    enabled={row.enabled}
                    isLast={index === rows.length - 1}
                    onToggle={() => handleToggle(row.id)}
                />
            ))}
        </div>
    );
}

export default MappingAttributeAdministration;
